module.exports = {
	"id": "JM",
	"name": "Jamaica",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006226,
			"11": 0.018678,
			"12": 0.006226,
			"13": null,
			"14": 0.006226,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.018678,
			"19": null,
			"20": 0.012452,
			"21": 0.024904,
			"22": 0.080938,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.018678,
			"27": null,
			"28": 0.012452,
			"29": 0.012452,
			"30": 0.012452,
			"31": 0.03113,
			"32": 0.018678,
			"33": 0.018678,
			"34": 0.018678,
			"35": 0.018678,
			"36": 0.03113,
			"37": 0.037356,
			"38": 0.03113,
			"39": 0.074712,
			"40": 0.018678,
			"41": 0.018678,
			"42": 0.024904,
			"43": 0.224136,
			"44": 0.03113,
			"45": 0.043582,
			"46": 0.06226,
			"47": 0.074712,
			"48": 0.09339,
			"49": 1.544048,
			"50": 0.168102,
			"51": 0.96503,
			"52": 0.56034,
			"53": 29.050516,
			"54": 7.863438,
			"55": 0.348656,
			"56": 0.105842,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.006226,
			"4": null,
			"5": null,
			"6": 0.006226,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.012452,
			"11": 0.006226,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.006226,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.006226,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.012452,
			"28": 0.012452,
			"29": 0.006226,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.018678,
			"34": 0.012452,
			"35": 0.012452,
			"36": 0.006226,
			"37": 0.012452,
			"38": 0.037356,
			"39": 0.018678,
			"40": 0.012452,
			"41": 0.018678,
			"42": 0.018678,
			"43": 0.112068,
			"44": 0.037356,
			"45": 0.074712,
			"46": 0.068486,
			"47": 0.398464,
			"48": 0.448272,
			"49": 4.17142,
			"50": 0.367334,
			"51": 0.012452,
			"52": 0.03113,
			"3.5": 0.006226,
			"3.6": 0.012452
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.018678,
			"28": null,
			"29": 0.099616,
			"30": null,
			"31": 0.006226,
			"32": null,
			"33": 0.03113,
			"34": 0.03113,
			"35": 0.006226,
			"36": 0.018678,
			"37": 0.329978,
			"38": 0.056034,
			"39": 0.018678,
			"40": 0.43582,
			"41": 0.068486,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.105842
		},
		"safari": {
			"0": null,
			"4": 0.006226,
			"5": 0.024904,
			"6": 0.012452,
			"7": 0.024904,
			"8": 0.087164,
			"9": 0.099616,
			"10": 0.915222,
			"3.1": null,
			"3.2": null,
			"5.1": 0.056034,
			"6.1": 0.018678,
			"7.1": 0.012452,
			"9.1": 0.572792
		},
		"ios_saf": {
			"8": 0,
			"10": 3.0571756786,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0823873470025,
			"8.1-8.4": 0.152207132598,
			"9.0-9.2": 0.0726125770192,
			"9.3": 1.10780726478
		},
		"android": {
			"3": 0,
			"4": 0.102258821705,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0127823527132,
			"4.1": 0.368862178295,
			"4.2-4.3": 0.922155445736,
			"4.4": 2.11456634884,
			"4.4.3-4.4.4": 2.13282685271
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.168482321267,
			"9": 0.17472240724,
			"10": 0.143521977376,
			"11": 2.25891112217,
			"5.5": null
		},
		"op_mob": {
			"0": 0.117119260401,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00325331278891
		},
		"edge": {
			"12": 0.230362,
			"13": 0.815606,
			"14": 1.612534
		},
		"ie_mob": {
			"10": 0.110137014085,
			"11": 0.448414985915
		},
		"bb": {
			"7": 0.133977,
			"10": null
		},
		"samsung": {
			"0": 2.513484
		},
		"and_uc": {
			"0": 1.841712
		},
		"op_mini": {
			"0": 1.57792742681
		},
		"and_chr": {
			"0": 24.862062
		},
		"and_ff": {
			"0": 0.030192
		}
	},
	"total": 97.9161868281
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/JM.json
 ** module id = 557
 ** module chunks = 0
 **/